import { validateAmounts } from "../utils";
import {
  EuerDeclarationOfficeUsageSubformFlatRate5EurInputs,
  EuerDeclarationOfficeUsageSubformCalculationResults,
} from "./types";

const FALLBACK_YEAR = 0;
const CALCULATION_CONFIG: Record<
  number, // year from which we have new calculation config
  { expensesPerDay: number; maxDaysUsed: number }
> = {
  [FALLBACK_YEAR]: {
    expensesPerDay: 5_00,
    maxDaysUsed: 120,
  },
  2023: {
    expensesPerDay: 6_00,
    maxDaysUsed: 210,
  },
};

const getLatestMatchedConfigYear = (declarationYear: number) =>
  Math.max(
    ...Object.keys(CALCULATION_CONFIG)
      .map((year) => Number(year))
      .filter((year) => year <= declarationYear)
  );

const getCalculationConfig = (declarationYear: number) => {
  const configYear = getLatestMatchedConfigYear(declarationYear);
  return CALCULATION_CONFIG[configYear];
};

export const calculateOfficeUsageSubformFlatRate5EurResults = (
  { daysUsed }: EuerDeclarationOfficeUsageSubformFlatRate5EurInputs,
  declarationYear: number
): EuerDeclarationOfficeUsageSubformCalculationResults => {
  validateAmounts([daysUsed]);

  const { maxDaysUsed, expensesPerDay } = getCalculationConfig(declarationYear);

  const homeOfficeExpenses = Math.min(daysUsed, maxDaysUsed) * expensesPerDay;

  return {
    homeOfficeExpenses,
    profitReduction: homeOfficeExpenses,
  };
};
